package one.healthium.ui.compose.components

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.selection.selectable
import androidx.compose.foundation.selection.selectableGroup
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme

val AppNavigationBarMinHeight = 70.dp

@Composable
fun AppNavigationBar(
    modifier: Modifier = Modifier,
    color: Color = AppTheme.navigationBarStyle.resolvedContainerColor,
    content: @Composable RowScope.() -> Unit
) {
    Surface(
        color = color,
        modifier = modifier
    ) {
        Row(
            modifier =
                Modifier.fillMaxWidth()
                    .windowInsetsPadding(WindowInsets.navigationBars)
                    .height(AppNavigationBarMinHeight)
                    .selectableGroup(),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically,
            content = content
        )
    }
}

@Composable
fun RowScope.AppNavigationBarItem(
    modifier: Modifier = Modifier,
    selected: Boolean,
    icon: @Composable () -> Unit,
    label: @Composable () -> Unit = {},
    onClick: () -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }

    Box(
        modifier
            .selectable(
                selected = selected,
                onClick = onClick,
                enabled = true,
                role = Role.Tab,
                interactionSource = interactionSource,
                indication = null,
            )
            .fillMaxHeight(),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            val contentColor = if (selected) {
                AppTheme.navigationBarStyle.resolvedActiveLabelColor
            } else {
                AppTheme.navigationBarStyle.resolvedDefaultLabelColor
            }
            CompositionLocalProvider(LocalContentColor provides contentColor) {
                icon()
                CompositionLocalProvider(LocalTextStyle provides AppTheme.textStyles.secondary_14_600) {
                    label()
                }
            }
        }
    }
}

@Composable
fun NavigationBarText(
    modifier: Modifier = Modifier,
    label: String,
    active: Boolean,
) {
    val textStyleActive = AppTheme.textStyles.secondary_16_500
    val textStyle = AppTheme.textStyles.secondary_16_400

    Text(
        modifier = modifier,
        text = label,
        style = if (active) {
            textStyleActive
        } else {
            textStyle
        },
        color = if (active) {
            AppTheme.navigationBarStyle.resolvedActiveLabelColor
        } else {
            AppTheme.navigationBarStyle.resolvedDefaultLabelColor
        },
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
    )
}
